var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.loader)?_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader__box"},[_vm._l((Object.values('ALTARA')),function(i){return _c('div',{staticClass:"loader__dot"},[_vm._v(_vm._s(i))])}),_c('div',{staticClass:"loader__text"})],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }